import '../../styles/muiStyles.css';
import '../../styles/filters.css';

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';


const Filter = ({ placeholder, options, onChange, value, type = 'select' }) => {

    const validOptions = Array.isArray(options) ? options : [];

    return (
        <div className="table-filter">
            {type === 'date' ? (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        label={placeholder}
                        value={dayjs(value)}
                        onChange={onChange}
                        format="DD/MM/YYYY"
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={placeholder}
                            />
                        )}
                    />
                </LocalizationProvider>
            ) : (
                <Autocomplete
                    value={value}
                    onChange={(event, newValue) => onChange(newValue)}
                    options={validOptions}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={placeholder}
                        />
                    )}
                    isOptionEqualToValue={(option, value) => option === value}
                />
            )}
        </div>
    );
};

export default Filter;